import type { FundraisingResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { FundraisingsGateway } from './fundraisings.gateway';

/**
 * Real implementation over the shared api client. This is the single place
 * that knows the fundraisings listing endpoint. `api.get` unwraps the
 * `{ success, data }` envelope, so we get the `FundraisingResponse[]` directly.
 */
export const httpFundraisingsGateway: FundraisingsGateway = {
  fetchFundraisings: () => api.get<FundraisingResponse[]>('/fundraisings'),
};
